import { Aktivitaet, AktivitaetTyp } from './types';

// anruf/meeting/aenderung kommen über eigene Mapper (nicht hier) → ausschließen,
// damit das switch erschöpfend bleibt.
export function zuAktivitaet(quellTyp: Exclude<AktivitaetTyp, 'anruf' | 'meeting' | 'aenderung'>, row: any): Aktivitaet {
  switch (quellTyp) {
    case 'email':
      return { typ: 'email', datum: row.datum || row.created_at, titel: row.betreff || '(kein Betreff)', detail: row.von || null, ziel: null, id: row.id, expandierbar: true };
    case 'ticket':
      return { typ: 'ticket', datum: row.created_at, titel: row.titel || '(Ticket)', detail: row.status || null, ziel: { typ: 'ticket', id: row.id }, id: row.id };
    case 'rechnung':
      return { typ: 'rechnung', datum: row.datum || row.created_at, titel: row.bezeichnung || row.unternehmen || '(Rechnung)', detail: row.brutto != null ? `${Number(row.brutto).toLocaleString('de-DE', { minimumFractionDigits: 2 })} €` : null, ziel: null, id: row.id };
    case 'dokument':
      return { typ: 'dokument', datum: row.created_at, titel: row.titel || row.datei_name || '(Dokument)', detail: row.kategorie || null, ziel: null, id: row.id };
    case 'termin':
      return { typ: 'termin', datum: row.start_datum || row.created_at, titel: row.titel || '(Termin)', detail: row.status || null, ziel: null, id: row.id };
    case 'notiz':
      return { typ: 'notiz', datum: row.created_at, titel: row.text, detail: null, ziel: null, id: row.id };
  }
}

// Feld-Namen → lesbare Labels für die Änderungs-Anzeige.
const FELD_LABEL: Record<string, string> = {
  status: 'Status', vorname: 'Vorname', nachname: 'Nachname', firma_name: 'Firma', email: 'E-Mail',
  telefon: 'Telefon', mobil: 'Mobil', einheit: 'Einheit', mietbeginn: 'Mietbeginn', mietende: 'Mietende',
  kaltmiete: 'Kaltmiete', nebenkosten_vorauszahlung: 'Nebenkosten', kaution: 'Kaution', zahlungsweise: 'Zahlungsweise',
  vertragsart: 'Vertragsart', vertragsstart: 'Vertragsstart', vertragsende: 'Vertragsende',
  name: 'Name', ansprechpartner: 'Ansprechpartner', aktiv: 'Aktiv', beauftragung_modus: 'Beauftragung',
  typ: 'Typ', festnetz: 'Festnetz', handynummer: 'Handy', kontaktart: 'Kontaktart',
};

// Audit-Zeile (entity_audit) → Timeline-Eintrag „Feld geändert: alt → neu".
export function auditZuAktivitaet(row: any): Aktivitaet {
  if (row.aktion === 'insert') {
    return { typ: 'aenderung', datum: row.geaendert_am, titel: 'Angelegt', detail: null, ziel: null, id: row.id };
  }
  if (row.aktion === 'delete') {
    return { typ: 'aenderung', datum: row.geaendert_am, titel: 'Gelöscht', detail: null, ziel: null, id: row.id };
  }
  const lbl = FELD_LABEL[row.feld as string] ?? row.feld ?? 'Feld';
  return {
    typ: 'aenderung',
    datum: row.geaendert_am,
    titel: `${lbl} geändert`,
    detail: `${row.alt_wert || '—'} → ${row.neu_wert || '—'}`,
    ziel: null,
    id: row.id,
  };
}

// Geloggte Aktivität (kontakt_aktivitaeten) → Timeline-Eintrag. 'mail' zeigt als 'email' (Mail-Icon),
// ist aber NICHT expandierbar (kein E-Mail-Body). Richtung/Dauer/Notiz landen im Detail.
export function logZuAktivitaet(row: any): Aktivitaet {
  const typ: AktivitaetTyp = row.typ === 'anruf' ? 'anruf' : row.typ === 'meeting' ? 'meeting' : 'email';
  const teile: string[] = [];
  if (row.richtung) teile.push(row.richtung === 'eingehend' ? 'Eingehend' : 'Ausgehend');
  if (row.dauer_minuten) teile.push(`${row.dauer_minuten} Min.`);
  if (row.notiz) teile.push(String(row.notiz));
  return { typ, datum: row.zeitpunkt, titel: row.betreff || '(ohne Betreff)', detail: teile.join(' · ') || null, ziel: null, id: row.id };
}
